export let names = {
    "AD": "Andorra",
    "AE": "Emiratos \u00c1rabes Unidos",
    "AF": "Afganist\u00e1n",
    "AG": "Antigua y Barbuda",
    "AI": "Anguila",
    "AL": "Albania",
    "AM": "Armenia",
    "AO": "Angola",
    "AQ": "Ant\u00e1rtida",
    "AR": "Argentina",
    "AS": "Samoa Americana",
    "AT": "Austria",
    "AU": "Australia",
    "AW": "Aruba",
    "AX": "\u00c5land, Islas",
    "AZ": "Azerbaiy\u00e1n",
    "BA": "Bosnia y Herzegovina",
    "BB": "Barbados",
    "BD": "Banglad\u00e9s",
    "BE": "B\u00e9lgica",
    "BF": "Burkina Faso",
    "BG": "Bulgaria",
    "BH": "Bahrein",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "San Barth\u00e9lemy",
    "BM": "Bermuda",
    "BN": "Brunei Darussalam",
    "BO": "Bolivia",
    "BQ": "Bonaire, San Eustaquio y Saba",
    "BR": "Brasil",
    "BS": "Bahamas",
    "BT": "Bhut\u00e1n",
    "BV": "Bouvet, Isla",
    "BW": "Botswana",
    "BY": "Belar\u00fas",
    "BZ": "Belice",
    "CA": "Canad\u00e1",
    "CC": "Cocos / Keeling",
    "CD": "Rep\u00fablica Democr\u00e1tica del Congo",
    "CF": "Rep\u00fablica Centroafricana",
    "CG": "Congo",
    "CH": "Suiza",
    "CI": "Costa de Marfil",
    "CK": "Islas Cook",
    "CL": "Chile",
    "CM": "Camer\u00fan",
    "CN": "China",
    "CO": "Colombia",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Cabo Verde",
    "CW": "Curazao",
    "CX": "Isla Christmas",
    "CY": "Chipre",
    "CZ": "Chequia",
    "DE": "Alemania",
    "DJ": "Djibouti",
    "DK": "Dinamarca",
    "DM": "Dominica",
    "DO": "Rep\u00fablica Dominicana",
    "DZ": "Argelia",
    "EC": "Ecuador",
    "EE": "Estonia",
    "EG": "Egipto",
    "EH": "S\u00e1hara Occidental",
    "ER": "Eritrea",
    "ES": "Espa\u00f1a",
    "ET": "Etiop\u00eda",
    "FI": "Finlandia",
    "FJ": "Fiji",
    "FK": "Islas Malvinas",
    "FM": "Micronesia",
    "FO": "Islas Feroe",
    "FR": "Francia",
    "GA": "Gab\u00f3n",
    "GB": "Reino Unido",
    "GD": "Granada",
    "GE": "Georgia",
    "GF": "Guayana Francesa",
    "GG": "Guernsey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GL": "Groenlandia",
    "GM": "Gambia",
    "GN": "Guinea",
    "GP": "Guadalupe",
    "GQ": "Guinea Ecuatorial",
    "GR": "Grecia",
    "GS": "Georgia del Sur y las Islas Sandwich del Sur",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HK": "Hong Kong",
    "HM": "Isla Heard e Islas McDonald",
    "HN": "Honduras",
    "HR": "Croacia",
    "HT": "Hait\u00ed",
    "HU": "Hungr\u00eda",
    "ID": "Indonesia",
    "IE": "Irlanda",
    "IL": "Israel",
    "IM": "Isla de Man",
    "IN": "India",
    "IO": "Territorio Brit\u00e1nico del Oc\u00e9ano \u00cdndico",
    "IQ": "Iraq",
    "IR": "Ir\u00e1n",
    "IS": "Islandia",
    "IT": "Italia",
    "JE": "Jersey",
    "JM": "Jamaica",
    "JO": "Jordania",
    "JP": "Jap\u00f3n",
    "KE": "Kenya",
    "KG": "Kirguist\u00e1n",
    "KH": "Camboya",
    "KI": "Kiribati",
    "KM": "Comoras",
    "KN": "Saint Kitts y Nevis",
    "KP": "Corea del Norte",
    "KR": "Corea del Sur",
    "KW": "Kuwait",
    "KY": "Islas Caim\u00e1n",
    "KZ": "Kazajst\u00e1n",
    "LA": "Lao",
    "LB": "L\u00edbano",
    "LC": "Santa Luc\u00eda",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesotho",
    "LT": "Lituania",
    "LU": "Luxemburgo",
    "LV": "Letonia",
    "LY": "Libia",
    "MA": "Marruecos",
    "MC": "M\u00f3naco",
    "MD": "Moldova",
    "ME": "Montenegro",
    "MF": "San Mart\u00edn",
    "MG": "Madagascar",
    "MH": "Islas Marshall",
    "MK": "Macedonia del Norte",
    "ML": "Mal\u00ed",
    "MM": "Myanmar",
    "MN": "Mongolia",
    "MO": "Macao",
    "MP": "Islas Marianas Septentrionales",
    "MQ": "Martinica",
    "MR": "Mauritania",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Mauricio",
    "MV": "Maldivas",
    "MW": "Malawi",
    "MX": "M\u00e9xico",
    "MY": "Malasia",
    "MZ": "Mozambique",
    "NA": "Namibia",
    "NC": "Nueva Caledonia",
    "NE": "N\u00edger",
    "NF": "Isla Norfolk",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Pa\u00edses Bajos",
    "NO": "Noruega",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "Nueva Zelandia",
    "OM": "Om\u00e1n",
    "PA": "Panam\u00e1",
    "PE": "Per\u00fa",
    "PF": "Polinesia Francesa",
    "PG": "Papua New Guinea",
    "PH": "Filipinas",
    "PK": "Pakist\u00e1n",
    "PL": "Polonia",
    "PM": "San Pedro y Miquel\u00f3n",
    "PN": "Pitcairn",
    "PR": "Puerto Rico",
    "PS": "Palestina",
    "PT": "Portugal",
    "PW": "Palau",
    "PY": "Paraguay",
    "QA": "Qatar",
    "RE": "Reuni\u00f3n",
    "RO": "Rumania",
    "RS": "Serbia",
    "RU": "Rusia",
    "RW": "Rwanda",
    "SA": "Arabia Saudita",
    "SB": "Salom\u00f3n, Islas",
    "SC": "Seychelles",
    "SD": "Sud\u00e1n",
    "SE": "Suecia",
    "SG": "Singapur",
    "SH": "Santa Elena, Ascensi\u00f3n y Trist\u00e1n de Acu\u00f1a",
    "SI": "Eslovenia",
    "SJ": "Svalbard y Jan Mayen",
    "SK": "Eslovaquia",
    "SL": "Sierra Leona",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somalia",
    "SR": "Suriname",
    "SS": "Sud\u00e1n del Sur",
    "ST": "Santo Tom\u00e9 y Pr\u00edncipe",
    "SV": "El Salvador",
    "SX": "San Mart\u00edn",
    "SY": "Rep\u00fablica \u00c1rabe Siria",
    "SZ": "Eswatini",
    "TC": "Turcas y Caicos",
    "TD": "Chad",
    "TF": "Tierras Australes Francesas",
    "TG": "Togo",
    "TH": "Tailandia",
    "TJ": "Tayikist\u00e1n",
    "TK": "Tokelau",
    "TL": "Timor-Leste",
    "TM": "Turkmenist\u00e1n",
    "TN": "T\u00fanez",
    "TO": "Tonga",
    "TR": "Turqu\u00eda",
    "TT": "Trinidad y Tabago",
    "TV": "Tuvalu",
    "TW": "Taiw\u00e1n",
    "TZ": "Tanzania",
    "UA": "Ucrania",
    "UG": "Uganda",
    "UM": "Islas menores alejadas de Estados Unidos",
    "US": "Estados Unidos de Am\u00e9rica",
    "UY": "Uruguay",
    "UZ": "Uzbekist\u00e1n",
    "VA": "Santa Sede",
    "VC": "San Vicente y las Granadinas",
    "VE": "Venezuela",
    "VG": "Islas V\u00edrgenes Brit\u00e1nicas",
    "VI": "Islas V\u00edrgenes de los Estados Unidos",
    "VN": "Viet Nam",
    "VU": "Vanuatu",
    "WF": "Wallis y Futuna",
    "WS": "Samoa",
    "YE": "Yemen",
    "YT": "Mayotte",
    "ZA": "Sud\u00e1frica",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
}

export default {
    names,
}
